import { RESIGNATION_STATUS_META } from "./constants";

const StatusBadge = ({ status, meta = RESIGNATION_STATUS_META }) => {
  const entry = meta[status] || {
    label: status || "-",
    className: "bg-gray-100 text-gray-600 border-gray-200",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${entry.className}`}
    >
      {entry.label}
    </span>
  );
};

export default StatusBadge;
